import * as React from 'react';
import {CustomPeriodDataMultiBtnSelect, IMultiNode} from '../../../CustomPeriodDataMultiBtnSelect';
import {DataMultiBtnSelect} from '../../../DataMultiBtnSelect';
import {CustomRangePeriodsDataSource, PeriodsDataSource} from '../../DataSources';
interface IPeriodsFilterProps {
  values: string[]
  useMobileMode?: boolean
  onChange?: (values: string[], source: IMultiNode[]) => void
  onClosed?: () => void
  defaultValue?: string
  useLinkView?: boolean
  rightAlign?: boolean
  persistLabel?: boolean
  placeholder?: string

  updateDateRange: (startDate: Date, endDate: Date) => void
  hasLoadedEvent?: (hasLoaded: boolean) => void

  dateRange: string
  startDateRange: Date
  endDateRange: Date
  disableDatePicker: boolean
  isDataLoading?: boolean;
  showMonthPicker?: boolean;
  disableSubmitButton?: boolean;
}

export class CustomPeriodsFilter extends React.Component<IPeriodsFilterProps, {}> {

  componentDidUpdate(prevProps: Readonly<IPeriodsFilterProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.dateRange !== this.props.dateRange && this.props.dateRange === 'N/A')
      this.props.updateDateRange(this.props.startDateRange, this.props.endDateRange)

  }

  render() {
    const {
      persistLabel = true,
      placeholder = 'Period',
      updateDateRange,
      startDateRange,
      endDateRange,
      disableDatePicker,
      dateRange,
      isDataLoading,
      showMonthPicker,
      disableSubmitButton ,
        hasLoadedEvent,
    } = this.props

    if (showMonthPicker) {
      return (
        <CustomPeriodDataMultiBtnSelect
          isDataLoading={isDataLoading}
          placeholder={placeholder}
          source={CustomRangePeriodsDataSource}
          useMobileMode={this.props.useMobileMode}
          rightAlign={this.props.rightAlign}
          useLinkView={this.props.useLinkView}
          values={this.props.values}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          onClosed={this.props.onClosed}
          persistLabel={persistLabel}
          hidePopoverOnLeadNodeSelect
          disableClearOnFirstSelect
          hidePopoverOnClear

          updateDateRange={(startDate, endDate) => {
            updateDateRange(startDate, endDate)
          }}
          hasLoadedEvent={(hasLoaded: boolean) => {
            if (hasLoadedEvent) {
              hasLoadedEvent(hasLoaded)
            }
          }}
          startDateRange={startDateRange}
          endDateRange={endDateRange}
          disableDatePicker={disableDatePicker}
          disableSubmitButton={disableSubmitButton}
        />
      )
    } else {
      return (
        <DataMultiBtnSelect
          placeholder={placeholder}
          source={PeriodsDataSource}
          useMobileMode={this.props.useMobileMode}
          rightAlign={this.props.rightAlign}
          useLinkView={this.props.useLinkView}
          values={this.props.values}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          onClosed={this.props.onClosed}
          persistLabel={persistLabel}
          hidePopoverOnLeadNodeSelect
          disableClearOnFirstSelect
          hidePopoverOnClear
        />
      )
    }
  }
}
